export default "__VITE_ASSET__d6f82ab1__"